import * as approvalDocMasterAmount from './actions';
import reducer from './reducer';

export interface InitialApprovalDocMasterAmount {
  requiredAmount: number,
  admitAmount: number,
  resultAmount: number,
  applicationApprovalReferenceAmount: number,
}


export {
  approvalDocMasterAmount,
};

export default reducer;
